<template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
        <div class="titleText">营业执照备案</div>
        <el-form-item label="证件类型" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择证件类型">
            <el-option label="企业营业执照" value="shanghai"></el-option>
            <el-option label="个体工商户营业执照" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照" prop="business">
          <div class="common-display">
              <div class="shancghau">
                <upload-img keyName="business" @getVal="getImgFun"></upload-img>
              </div>
              <div class="textRU">
                  1. 需提供营业执照原件扫描件或加盖公司公章的复印件，不可截屏摄屏<br/>
                  2. 营业执照未注吊销，且有效期截止时间大于15天<br/>
                  3. 由于新注册执照存在公示期，信息可能更新不及时，建议您自注册之日起【14个工作日】后再入驻<br/>
                  4. 图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB<br/>
              </div>
          </div>
        </el-form-item>
        <div class="titleText" style="padding-top:60px">品牌信息</div>
        <el-form-item label="品牌名称" prop="prName">
            <el-input v-model="ruleForm.prName" placeholder="请输入品牌名称" style="width:358px;"></el-input>
        </el-form-item>
        <el-form-item label="认证类型">
            <el-radio v-model="ruleForm.certification" label="1">上传非商标品牌资质</el-radio>
            <el-radio v-model="ruleForm.certification" label="2">上传商标注册证</el-radio>
        </el-form-item>
        <el-form-item label="门头图片" prop="isDoor">
          <div class="common-display">            
              <div class="shancghau">
                <upload-img keyName="doorOne" @getVal="getImgFun"></upload-img>
              </div>
              <div class="shancghau" style="margin-left:10px;">
                <upload-img keyName="doorTwo" @getVal="getImgFun"></upload-img>
              </div>
              <div class="textRU">
                  1. 请上传不少于两张线下真实清晰的门店门头图，需可判断分属不同门店，门头需包含品牌名称，以证明品牌名称实际存在<br/>
                  2. 请保证门头图清晰可见，门头招牌无遮挡，不接受临时店招<br/>
                  3. 图片支持PNG、JPG和JPEG格式，大小不超过5MB<br/>
                  <span style="color:red">4. 请上传两张不同的门头图</span><br/>
              </div>
          </div>
        </el-form-item>
        <el-form-item label="门店1营业执照" prop="shopOne">
          <div class="common-display">
              <div class="shancghau">
                <upload-img keyName="shopOne" @getVal="getImgFun"></upload-img>
              </div>
              <div class="textRU">
                  1. 需提供营业执照原件扫描件或加盖公司公章的复印件，不可截屏摄屏，执照内各关键字段完整，执照法人需保持一致或存在企业关联关系<br/>
                  2. 营业执照未注吊销，且有效期截止时间大于15天<br/>
                  3. 图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB<br/>
              </div>
          </div>
        </el-form-item>
        <el-form-item label="门店2营业执照">
          <div class="common-display">
              <div class="shancghau">
                 <upload-img keyName="shopTwo" @getVal="getImgFun"></upload-img>
              </div>
              <div class="textRU">
                  1. 需提供营业执照原件扫描件或加盖公司公章的复印件，不可截屏摄屏，执照内各关键字段完整，执照法人需保持一致或存在企业关联关系<br/>
                  2. 营业执照未注吊销，且有效期截止时间大于15天<br/>
                  3. 图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5MB<br/>
              </div>
          </div>
        </el-form-item>
        <el-form-item label="其他补充信息" >
          <div class="common-display">
              <div class="shancghau">
                 <upload-img keyName="supple" @getVal="getImgFun"></upload-img>
              </div>
              <div class="textRU">
                  1. 执照法人不一致的情况下，请补充来源为企信网或天眼查的企业关联关系图谱。<br/>
                    <span style="padding-left:12px">法人间的个人关联（如夫妻父母、兄弟姐妹等）、私下的股权分红协议等不可作为企业主体关联证明。</span><br/>
                  2. 图片支持PNG、JPG和JPEG格式，大小不超过5MB
              </div>
          </div>
        </el-form-item>
        <div style="display:flex;padding-top:60px;">
            <div style="margin-right:220px">
                <div class="titleText" style="padding-bottom:30px;">经营范围</div>
                <el-form-item label="入驻类型" prop="businessType">
                    <el-select v-model="ruleForm.businessType" placeholder="请选择证件类型">
                      <el-option label="嘉马商城" value="jiamashangc"></el-option>
                      <el-option label="繁淼充电桩" value="fanmiaochongdianz"></el-option>
                      <el-option label="嘉马民宿" value="jiamamins"></el-option>
                      <el-option label="智慧消防" value="zhuihuixiaofang"></el-option>
                    </el-select>
                </el-form-item>
                <div class="titleText" style="padding-top:20px;padding-bottom:30px;">法人信息</div>
                <el-form-item label="法人实名信息" prop="legal">
                    <el-select v-model="ruleForm.legal" placeholder="请选择证件类型">
                      <el-option label="身份证" value="shenfenz"></el-option>
                      <el-option label="港澳通行证" value="gangao"></el-option>
                      <el-option label="台湾通行证" value="tawan"></el-option>
                      <el-option label="护照" value="huiz"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传身份证" prop="isIdentity">
                  <div class="common-display">
                      <div class="shancghau">
                        <upload-img keyName="identityOne" @getVal="getImgFun"></upload-img>
                      </div>
                      <div class="shancghau" style="margin-left:10px">
                        <upload-img keyName="identityTwo" @getVal="getImgFun"></upload-img>
                      </div>
                  </div>
                </el-form-item>
            </div>
            <!--预付金-->
            <advance></advance>
        </div>
        <el-form-item>
          <div style="opacity:0">
               <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
               <el-button @click="resetForm('ruleForm')">重置</el-button>
          </div>
        </el-form-item>
    </el-form>
</template>
<script>
import UploadImg from '../../../components/uploadImg.vue';
import advance from './advance.vue'
import { popSFun,popWFun } from '@/utils/utils'
export default {
  components:{
    advance,
    UploadImg
  },
  data() {
    return {
      ruleForm: {
          type:'',        // 证件类型
          prName:'',      // 品牌名称
          certification:'1',// 认证类型
          isDoor:'',      //是否上传门头图
          business:'',    // 营业执照
          doorOne:'',     // 门头照1
          doorTwo:'',     // 门头照2
          shopOne:'',     // 门店照1
          showTwo:'',     // 门店照2
          supple:'',      // 补充材料
          businessType:'',// 经营类型
          legal:'',       // 法人实名信息
          isIdentity:'',   // 是否上传身份证
          identityOne:'', // 身份证正面
          identityTwo:'', // 身份证反面
      },
      rules: {
        type:[
          { required:true,message:'请选择证件类型',trigger:'change' }
        ],
        business:[
          { required: true, message: '请上传营业执照', trigger: 'blur'}
        ],
        prName:[
          { required: true, message: '请输入品牌名称', trigger: 'blur' }
        ],
        certification:[
          { required: true, message: '请选择认证类型', trigger: 'change' }
        ],
        isDoor:[
          {required: true, message: '请上传门头图', trigger: 'change'}
        ],
        shopOne:[
          {required:true,message:'请上传门店1营业执照',trigger:'change'}
        ],
        shopTwo:[
          {required: true,message:'请上传门店2营业执照',trigger:'change'}
        ],
        supple:[
          {required: true,message:'请上传补充材料',trigger:'change'}
        ],
        businessType:[
          {required: true,message:'请选择经营类型',trigger:'change'}
        ],
        legal:[
          {required: true,message:'请上传法人实名信息',trigger:'change'}
        ],
        isIdentity:[
          {required: true,message:'请上传身份证',trigger:'change'}
        ]
      }
    };
  },
  mounted() {
     this.login()
  },
  methods: {
    // https://pro.brjxf119.com/api/charging-web-service/project/addProject
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {     
            delete this.ruleForm.isDoor;
            delete this.ruleForm.isIdentity;
            console.log("资料参数",this.ruleForm)
            let param =  {...this.ruleForm,...{"name":"兴东地铁口","projectType":4,"address":",松山湖风景区松山湖风景区松湖烟雨","areaAddress":"广东省,东莞市,大朗镇","codeAddress":"440000,441900,44190027","longiLatitude":"113.883094,22.916779","contacts":"胡","phone":"15869996183","marks":"","smId":"1702577369225220098","extendAddress":"测试详址","transferConfig":{"deleteIds":[],"list":[{"account":"shanshan","chargersPhone":"15327185743","chargersUserId":117,"operator":"珊珊","shareRatio":"100","transferMethod":"juhefu"}]}}};
            console.log('param',param)

            fetch('https://pro.brjxf119.com/api/charging-web-service/project/addProject',{
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': window.localStorage.getItem('Gukantoken')
              },
              body:JSON.stringify(param)
            }).then(res=>res.json())
            .then(res=>{
              if(res.data){
                popSFun('提交成功 请等待审核')
              }else{
                popWFun('提交失败')
              }
            })
            // this.sunbitBtn()
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      getImgFun(e){
        this.ruleForm[e.keyName] = e.valE;
        if(!!this.ruleForm.doorOne && !!this.ruleForm.doorTwo)
          this.ruleForm.isDoor = '1'
        else 
          this.ruleForm.isDoor = ''

        if(!!this.ruleForm.identityOne && !!this.ruleForm.identityTwo)
          this.ruleForm.isIdentity = '1'
        else
          this.ruleForm.isIdentity = ''
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

      //登录信息
      login(){
        fetch("https://pro.brjxf119.com/api/auth-service/auth/login", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              mode:"cors",
              body:JSON.stringify({
                 account:"shanshan",
                 password:"e10adc3949ba59abbe56e057f20f883e",
                 platform:"7",
                 model:"1"
              })
            }).then(function(res) {
              if (res.status === 200) {
                  return res.json()
              } else { }
            }).then(function(data) {
                  localStorage.setItem('Gukantoken',data.data)
            }).catch(function(err) {
             
        });
      },

      sunbitBtn(){
      
        // Object.keys(this.ruleForm).forEach((key)=>{
        //   if(key == 'certification'){
        //     this.ruleForm[key] = '1'
        //   }else { 
        //     this.ruleForm[key] = ''
        //   }
        //  })
        
         console.log(this.resetForm)
         console.log(parms)
      }

  }
}
</script>
<style lang="scss">
   .titleText{
      font-size: 24px;
      font-family: AlibabaPuHuiTi_2_85_Bold;
      color: #333333;
      font-weight:600;
      padding-bottom:47px;
   }
   .shancghau{
       width:104px;
       height:104px;
       overflow:hidden;
       border-radius:4px;
       .img{
          width:100%;
       }
   }
   .textRU{
      font-size:12px;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      color: #333333;
      line-height:20px;
      margin-left:12px;
   }
</style>